export const EMPTY_TRADE_VALUE = '-';

const hasNumberValue = (value?: number | null): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const formatDollarValue = (value?: number | null, decimals?: number): string => {
  if (!hasNumberValue(value)) {
    return EMPTY_TRADE_VALUE;
  }

  return decimals == null ? `$${value}` : `$${value.toFixed(decimals)}`;
};

export const formatWholePercent = (value?: number | null): string => {
  if (!hasNumberValue(value)) {
    return EMPTY_TRADE_VALUE;
  }

  return `${Math.round(value)}%`;
};

export const formatRatioAsWholePercent = (value?: number | null): string => {
  if (!hasNumberValue(value)) {
    return EMPTY_TRADE_VALUE;
  }

  return `${Math.round(value * 100)}%`;
};
